<style lang="stylus">
    .teamsAppLeftPanel
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.3);
        z-index: 12;
        height: 100vh;
        .teamsAppLeftPanel-content
            width: 200px;
            height: 100vh;
            background: #fff;
            position: fixed;
            left: 0;
            top: 0;
        .menu
            li
                display flex
                align-items center
                position relative
                height 48px
                list-style none
                overflow auto
                user-select none
                cursor pointer
                font-size 14px
                @media screen and (min-height: 888px)
                    height 56px
                >img
                    display block
                    margin-left 14px
                .menu-img
                    flex-shrink 0
                    margin-left 20px
                    width 32px
                    height 32px
                    fill #ffffff
                    stroke #ffffff
                .board-menu-img
                    margin-left 24px
                .menu-img-pc
                    flex-shrink 0
                    margin-left 20px
                    width 20px
                    height 20px
                    fill #ffffff
                    stroke #ffffff

                .menu-text-online
                    margin-left 8px
                    color rgba(34, 34, 34, 0.8)
                .menu-text
                    font-size 13px
                    line-height 24px
                    margin-left 12px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                .meun-item-suffix
                    position absolute
                    right 16px
                    width 24px
                    height 24px
                    &:hover
                        background-color rgba(1, 127, 255, 0.1)

                &:hover:not(.active)
                    background-color rgba(170, 180, 193, 0.2)
                &.active
                    color var(--themeColor)
                    .menu-text-online
                        font-weight 700
        .logobox-box
            padding 10px 15px
            img
                height 48px
                width 100%
</style>

<template>
    <div class="teamsAppLeftPanel" @click="showLeftPanel = false">
        <div class="teamsAppLeftPanel-content" @click.stop :style="contentStyle">
            <div class="logobox-box">
                <img class="logobox-img" :src="logoIcon" alt="" />
            </div>
            <ul class="menu">
                <template v-for="item in menuList">
                    <li
                        :key="item.id"
                        @click="clickMenu(item.id)"
                        :data-locate="item.name"
                        :class="{ active: selectId === item.id, myDocSlide: item.id === 1, myShareSlide: item.id === 5, 'online-li': !isPC }"
                    >
                        <img
                            class="menu-img"
                            :src="require(`@/home/assets/img/slider/${selectId !== item.id ? item.img : item.img + '-active' + themeIndex}.svg`)"
                            alt=""
                        />
                        <p class="menu-text" :class="{ 'menu-text-online': !isPC }">{{ $t(item.name) }}</p>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class teamsAppLeftPanel extends Vue {
        menuList: Array<any> = [
            {
                id: 1,
                name: "workbench",
                img: "cloudIcon",
            },

            {
                id: 6,
                name: "trash",
                img: "trashIcon",
            },
        ];
        get selectId() {
            return this.$store.state.selectId;
        }
        set selectId(value) {
            this.$store.commit("setState", { data: value, type: "selectId" });
        }
        get themeIndex() {
            return this.$store.state.themeIndex;
        }
        get logoIcon() {
            let lang = this.internal ? "zh" : "en";
            return require(`@/home/assets/img/logo-icon-${lang}.svg`);
        }
        get contentStyle() {
            return {
                transform: this.showLeftPanel ? "translate3d(0px, 0px, 0px)" : "translate3d(-200px, 0px, 0px)",
            };
        }
        clickMenu(id) {
            this.$bus.$emit("teamsappClickMenu", id);
            this.showLeftPanel = false;
        }
        get showLeftPanel() {
            return this.$store.state.showLeftPanel;
        }
        set showLeftPanel(val) {
            this.$store.commit("setState", {
                type: "showLeftPanel",
                data: val,
            });
        }
    }
</script>
